<div class="countdown-container {{ element.settings?.general?.countdownPosition }}">
    <ng-container *ngIf="countdownRender$ | async as countdownRender">
        <div *ngIf="isComponentReady && countdownRender.isOnTime" [ngClass]="this.activeFont" class="container-time">
            <div class="direction-container" dir="ltr">
                <div *ngIf="!onlyHours && countdownRender.days >= 1" class="column-time">
                    <div class="inline" [ngStyle]="{ 'font-size': this.sizeDateEnd, 'color': this.colorDateEnd }">
                        {{ countdownRender.daysView }}
                    </div>
                    <div [dir]="direction">
                        <div *ngIf="!hideLabels" class="inline" [ngStyle]="{ 'font-size': this.lowerTextSize, 'color': this.colorDateEnd }">
                            <span *ngIf="countdownRender.days === 1">
                                {{ 'dev.general.countdown.day' | translate }}
                            </span>
                            <span *ngIf="countdownRender.days > 1 || countdownRender.days === 0">
                                {{ 'dev.general.countdown.days' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- Hours -->
                <div [ngClass]="{ 'column-time': !hideLabels }">
                    <div class="inline" [ngStyle]="{ 'font-size': this.sizeDateEnd, 'color': this.colorDateEnd }">
                        {{ countdownRender.hoursView
                        }}<span *ngIf="hideLabels" [ngStyle]="{ 'font-size': this.sizeDateEnd, 'color': this.colorDateEnd }">:</span>
                    </div>
                    <div [dir]="direction">
                        <div *ngIf="!hideLabels" class="inline" [ngStyle]="{ 'font-size': this.lowerTextSize, 'color': this.colorDateEnd }">
                            <span *ngIf="countdownRender.hours === 1">
                                {{ 'dev.general.countdown.hour' | translate }}
                            </span>
                            <span *ngIf="countdownRender.hours > 1 || countdownRender.hours === 0">
                                {{ 'dev.general.countdown.hours' | translate }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Minutes -->
                <div [ngClass]="{ 'column-time': !hideLabels }">
                    <div class="inline" [ngStyle]="{ 'font-size': this.sizeDateEnd, 'color': this.colorDateEnd }">
                        {{ countdownRender.minutesView
                        }}<span *ngIf="hideLabels" [ngStyle]="{ 'font-size': this.sizeDateEnd, 'color': this.colorDateEnd }">:</span>
                    </div>
                    <div [dir]="direction">
                        <div *ngIf="!hideLabels" class="inline" [ngStyle]="{ 'font-size': this.lowerTextSize, 'color': this.colorDateEnd }">
                            <span *ngIf="countdownRender.minutes === 1">
                                {{ 'dev.general.countdown.minute' | translate }}
                            </span>
                            <span *ngIf="countdownRender.minutes > 1 || countdownRender.minutes === 0">
                                {{ 'dev.general.countdown.minutes' | translate }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Seconds -->
                <div class="column-time column-time-segs">
                    <div class="opacity inline" [ngStyle]="{ 'font-size': this.sizeDateEnd, 'color': this.colorDateEnd }">88</div>
                    <div class="inline column-time-segs-inner" [ngStyle]="{ 'font-size': this.sizeDateEnd, 'color': this.colorDateEnd }">
                        {{ countdownRender.secondsView }}
                    </div>
                    <div [dir]="direction">
                        <div *ngIf="!hideLabels" class="inline" [ngStyle]="{ 'font-size': this.lowerTextSize, 'color': this.colorDateEnd }">
                            <span *ngIf="countdownRender.seconds === 1">
                                {{ 'dev.general.countdown.second' | translate }}
                            </span>
                            <span *ngIf="countdownRender.seconds > 1 || countdownRender.seconds === 0">
                                {{ 'dev.general.countdown.seconds' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="progress-bar" [ngStyle]="{ margin: marginProgressBar }">
                    <md-progress-bar [color]="colorProgressBar" [currentProgress]="percentLeft" [size]="sizeProgressBar"> </md-progress-bar>
                </div>
            </div>
        </div>
    </ng-container>
</div>
